import api from './api';

export const checkEligibility = (data) =>
  api.post('/api/v1/eligibility', data).then((r) => r.data.data);

export const getEligibilityChecks = (params) =>
  api.get('/api/v1/eligibility', { params }).then((r) => r.data.data);

export const getEligibilityCheck = (id) =>
  api.get(`/api/v1/eligibility/${id}`).then((r) => r.data.data);

export const checkClaimStatus = (claimId) =>
  api.post(`/api/v1/insurance/claims/${claimId}/status-check`).then((r) => r.data.data);
